import { HttpParams } from '@angular/common/http';
import { ApiService } from '@libs/core/base-config';
import { omitUndefinedValues } from '@libs/core/lib/utils/utils';
import { Dtos, walletSchema } from '@libs/mtjr/shared/generated/types';
import { map } from 'rxjs';

export function getUserWallet(apiService: ApiService, queryParams: Dtos.GetUserWalletQueryParams) {
  const params = new HttpParams({ fromObject: omitUndefinedValues(queryParams) });
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/wallets/get-user-wallet`, { params })
    .pipe(map((data) => walletSchema().parse(data)));
}
